module.exports = __webpack_public_path__ + "img/what-is-gloveler.3474b1e8.jpg";